import ScrollMagic from 'scrollmagic';
var controller = new ScrollMagic.Controller();

//スクロールアニメーション
class ScrollFade {
	constructor() {
		this.ANIMATION_CLASS = 'is_fire';
  
		let $section = document.querySelectorAll('.anim:not(.is_fire)');
		if($section.length === null) {
			return;
		}
		let controller = new ScrollMagic.Controller();
		for(let i = 0; i < $section.length; i++) {
			let scene = new ScrollMagic.Scene({
				triggerElement: $section[i],
				triggerHook: 'onEnter',
				reverse: false,
				offset: 100
			})
				.addTo(controller);
			scene.on('enter', ()=>{
				$section[i].classList.add(this.ANIMATION_CLASS);
			});
			scene.on('end', ()=>{
				scene.destroy(true);
			});
		}
	}
}

new ScrollFade();

var $ = require('jquery');

new ScrollMagic.Scene({triggerElement: "#intro"})
					.setClassToggle("#header", "active") // add class toggle
					.addTo(controller);

var $fg = $(".figure__img");
var scene1 = new ScrollMagic.Scene({triggerElement: "#figure", duration: 1600 , triggerHook : "onEnter"})
.on("progress", function (prog) {
    var p = prog.progress;
    $fg.css({
        //opacity: 1 * p,
        transform: "scale(" + (1 + 0.15 * p) + ")"
    });
})
.addTo(controller);
